module.exports = __webpack_public_path__ + "img/watch.3d51ec5a.png";